import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { getSetting } from "../../../../utils/frontendSettingsManager";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import HideSomeInfo from "../../../elements/hideSomeInfo/HideSomeInfo";
import Notification from "../../../elements/notification/Notification";
import BalancesFilter from "../../../elements/balances/BalancesFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import BalanceNotificationButton from "../../../elements/balances/BalanceNotificationButton";
import { Helmet } from "react-helmet-async";
import CashFlowBalancesList from "./CashFlowBalancesList";
import { useTranslation } from "react-i18next";

import { frontendSettings, HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import { StyledUserBalancesWrapper } from "../../../account/styledAccount";
import { parseAxiosError } from "../../../../utils/response";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const CashFlowBalancesContainer = () => {
  const { t } = useTranslation("cashFlow");
  const [balances, setBalances] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [hideZeroBalances, setHideZeroBalances] = useState(getSetting(frontendSettings.hideZeroBalancesAdmin) ?? false);
  const hideZeroBalancesRef = useRef();
  hideZeroBalancesRef.current = hideZeroBalances;

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "balances", false, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null),
    "totalAmount[gte]": checkFilterItem(history, "totalAmount[gte]", null, true),
    "totalAmount[lte]": checkFilterItem(history, "totalAmount[lte]", null, true)
  });

  const fetchBalanceStatistics = (data) => {
    let fetchingData = [];

    for (let [key, row] of Object.entries(data)) {
      row[0].amount = row.totalAmount;
      fetchingData.push(row[0]);
    }

    return fetchingData;
  };

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    if (hideZeroBalancesRef.current) {
      filterUrl += `&${frontendSettings.hideZeroBalances}=true`;
    }

    axios.get("/api/balances/statistic-list" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK && response.data.hasOwnProperty("balancesList")) {

        setBalances(response.data["balancesList"]);
        setTotalPageCount(response.data["totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, [filterData, hideZeroBalances]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  // TODO Add pusher
  const updateBalance = (message) => {
    const data = JSON.parse(message.data);
    const index = balances.findIndex(item => item.id === data.id);
    if (index >= 0) {
      balances[index].diff = `${data.amount > balances[index].amount ? "+" : ""}${data.amount -
      balances[index].amount}`;
      balances[index].amount = data.amount;
      let newArr = [];
      setBalances([
        ...balances,
        ...newArr
      ]);
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <Helmet>
        <title>{t("balances.meta.title")}</title>
      </Helmet>
      <StyledUserBalancesWrapper>
        <div className="content-head cash-flow-balance-head">
          <BalancesFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
          <HideSomeInfo
            data={hideZeroBalances}
            setData={setHideZeroBalances}
            name={frontendSettings.hideZeroBalancesAdmin}
            label={t("balances.hideZeroBalances")}
          />
          {/*<BalanceNotificationButton*/}
          {/*  notification={notification}*/}
          {/*  setNotification={setNotification}*/}
          {/*/>*/}
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <CashFlowBalancesList
          balances={balances}
          setBalances={setBalances}
        />
        {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
      </StyledUserBalancesWrapper>
    </>
  );
};

export default CashFlowBalancesContainer;